import { useParsedQuery } from '@/hooks/useParsedQuery'
import { DATE_FORMAT } from '@/utils/consts'
import dayjs from 'dayjs'
import { OutboundSchedulePageQueryParams, OutboundScheduleShipperCode } from '../types/query'
import { useScheduleShipperCode } from '../context/ScheduleShipperContext'

/**
 *  컷오프 일자 조회 (화주사 코드 없음)
 *  - 쿼리 파라미터 없으면 오늘 날짜 반환
 *  - 컷오프 일자 시작은 00시가 아닌, 전날 23시부터 시작 -> 오늘 시간이 23:00~23:59 일때 내일로 취급
 *  - 이전날짜도 같이 제공
 *  - ScheduleShipperProvider 밖(index.tsx 헤더)에서도 쓸 수 있다
 */
export const useCutOffDateOnly = (): { cutOffDate: string; prevCutOffDate: string } => {
  const { parsedQs } = useParsedQuery<OutboundSchedulePageQueryParams>()

  if (parsedQs.date) {
    return {
      cutOffDate: parsedQs.date,
      prevCutOffDate: dayjs(parsedQs.date).subtract(1, 'day').format(DATE_FORMAT.date),
    }
  }

  const now = dayjs()
  const currentHour = now.hour()

  const targetDate = currentHour >= 23 ? now.add(1, 'day') : now
  const cutOffDate = targetDate.format(DATE_FORMAT.date)

  return {
    cutOffDate,
    prevCutOffDate: dayjs(cutOffDate).subtract(1, 'day').format(DATE_FORMAT.date),
  }
}

/**
 *  컷오프 일자 + 화주사 코드
 *  - 화주사 코드는 허용 화주로 확정된 값만 쓴다 (LOGISPRD-12495) — ScheduleShipperProvider 안에서만 호출
 */
export const useCutOffDate = (): { cutOffDate: string; prevCutOffDate: string; shipperCode: OutboundScheduleShipperCode } => {
  const { cutOffDate, prevCutOffDate } = useCutOffDateOnly()
  const shipperCode = useScheduleShipperCode()

  return { cutOffDate, prevCutOffDate, shipperCode }
}
